//This data will be static to users
const defaults = {
  block: {
    blurb: {
      balance_columns: 0,
      block_inset: "",
      block_type: "blurb",
      column_flow: "horizontal",
      columns: 1,
      name_on_left: 0,
      ragged_gutter: 0,
      side_by_side: 0,
      text_alignment: "center",
      block_Alignment:''
    },
    image: {
      balance_columns: 0,
      block_inset: "",
      block_type: "image",
      column_flow: "",
      columns: 1,
      name_on_left: 0,
      ragged_gutter: 0,
      side_by_side: 0,
      text_alignment: "center",
      block_Alignment:''
    },
    logo: {
      balance_columns: 0,
      block_inset: "",
      block_type: "logo",
      column_flow: "",
      columns: 1,
      name_on_left: 0,
      ragged_gutter: 0,
      side_by_side: 0,
      text_alignment: "center",
      block_Alignment:''
    },
    nameonly: {
      balance_columns: 0,
      block_inset: "",
      block_type: "nameonly",
      column_flow: "horizontal",
      columns: 1,
      name_on_left: 0,
      ragged_gutter: 0,
      side_by_side: 0,
      text_alignment: "center",
      block_Alignment:''
    },
    rolename: {
      balance_columns: 0,
      block_inset: "",
      block_type: "rolename",
      column_flow: "",
      columns: 2,
      name_on_left: 0,
      ragged_gutter: 0,
      side_by_side: 0,
      text_alignment: "center",
      block_Alignment:'gutter'
    },
    song: {
      balance_columns: 0,
      block_inset: "",
      block_type: "song",
      column_flow: "vertical",
      columns: 2,
      name_on_left: 0,
      ragged_gutter: 0,
      side_by_side: 0,
      text_alignment: "gutter",
      block_Alignment:''
    },
  },
  variables: {
    balance_columns: [0, 1],
    block_inset: ["", "left", "right"],
    block_type: ["rolename", "nameonly", "logo", "image", "song", "blurb"],
    column_flow: ["", "horizontal", "vertical"],
    columns: [0, 1, 2, 3, 4, 5],
    name_on_left: [0, 1],
    ragged_gutter: [0, 1, 2, 3, 4],
    side_by_side: [0, 1],
    text_alignment: ["left", "right", "center", "gutter", "justified"],
    block_Alignment:''
  },
  options: [
    "block_type",
    "block_inset",
    "heading",
    "subheading",
    "columns",
    "column_width",
    "column_flow",
    "rolling_single",
    "name_on_left",
    "side_by_side",
    "text_alignment",
   " blockAlign",
    "matte",
    "ragged_gutter",
    "balance_columns",
    "extra_lines_below",
    "horizontal_gap",
    "dot_leaders",
  ],
};

// we will convert credits received from the google sheet into this format. Please ignore the id's for now.
const credits = [
  {
    items: [
      {
        id: 115928366,
        name: "scrollx.com",
        position: 3,
        role: "Sign in to the app:",
      },
      {
        id: 115928367,
        position: 4,
      },
      {
        id: 115928368,
        name: "support@endcrawl.com",
        position: 5,
        role: "Need help getting started?",
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "welcome",
      block_type: "rolename",
      column_flow: "",
      column_width: 50,
      columns: 2,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "Welcome to Endcrawl.kffhmmbhmjhmbfghfhg\nyhgjhikgbggfb\n\n",
      id: 396408,
      name_on_left: 0,
      position: 2,
      ragged_gutter: 4,
      rolling_single: 1,
      side_by_side: 0,
      subheading:
        'This is a "sandbox" project for you to learn and explore Endcrawl\nwithout breaking anything in production\n\n\n\n',
      text_alignment: "center",
      blockAlign:'gutter'
    },
  },
  {
    items: [
      {
        blurb:
          "Use ROLE + NAME blocks for common credits\nlike cast, crew, and vendors:",
        id: 115928369,
        position: 7,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "explainer-1",
      block_type: "blurb",
      column_flow: "horizontal",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "1.",
      id: 396413,
      name_on_left: 0,
      position: 6,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      text_alignment: "center",
      blockAlign:'gutter'
    },
  },
  {
    items: [
      {
        id: 115928370,
        name: "कुमारी आशा",
        position: 9,
        role: "Unit Production Manager",
      },
      {
        id: 115928371,
        position: 10,
      },
      {
        id: 115928372,
        name: "Darryl “D.M.C.” McDaniels",
        position: 11,
        role: "First Assistant Director",
      },
      {
        id: 115928373,
        name: "Jason “Jam Master Jay” Mizell",
        position: 12,
        role: "Second Assistant Director",
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "dga-singles",
      block_type: "rolename",
      column_flow: "",
      column_width: 50,
      columns: 2,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "dga single",
      id: 396396,
      name_on_left: 0,
      position: 8,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: "uihyfuyhduiscf",
      text_alignment: "gutter",
    },
  },
  {
    items: [
      {
        id: 115928374,
        name: "Hemant Gupta sir",
        position: 14,
        role: "Dorothy",
      },
      {
        id: 115928375,
        name: "Kartikye Gupta",
        position: 15,
        role: "Hushpuppy",
      },
      {
        id: 115928376,
        name: "Bhavna Gupta",
        position: 16,
        role: "Young Tristan",
      },
      {
        id: 115928377,
        name: "Lupita Nyong'o",
        position: 17,
        role: "Maz Kanata",
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "cast",
      block_type: "nameonly",
      column_flow: "horizontal",
      column_width: 50,
      columns: 2,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "CAST Of the Mpvoe",
      id: 396395,
      name_on_left: 0,
      position: 13,
      ragged_gutter: 0,
      rolling_single: 1,
      side_by_side: 0,
      subheading: "Ca",
      text_alignment: "center",
      blockAlign:'gutter'
    },
  },
  {
    items: [
      {
        id: 115928386,
        name: "Billie Jean King",
        position: 27,
        role: "Production Supervisor",
      },
      {
        id: 115928387,
        position: 28,
      },
      {
        id: 115928388,
        name: "Barbara McClintock",
        position: 29,
        role: "Art Director",
      },
      {
        id: 115928389,
        name: "Aspasia of Miletus",
        position: 30,
        role: "Set Decorator",
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "crew",
      block_type: "rolename",
      column_flow: "",
      column_width: 50,
      columns: 2,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "CREWxasx ",
      id: 396394,
      name_on_left: 0,
      position: 26,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: "",
      text_alignment: "gutter",
      block_Alignment:'gutter'
    },
  },
  {
    items: [
      {
        blurb:
          "The NAME ONLY block type is useful for groups of people who share the same credit.\nThis can have between 1 and 5 columns, or be bulleted.",
        id: 115928395,
        position: 37,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "explainer-2",
      block_type: "blurb",
      column_flow: "horizontal",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "2.",
      id: 396398,
      name_on_left: 0,
      position: 36,
      ragged_gutter: 0,
      rolling_single: 2,
      side_by_side: 0,
      text_alignment: "right",
    },
  },
  {
    items: [
      {
        id: 115928396,
        name: "Charles Becker",
        position: 39,
        role: "Production Assistants",
      },
      {
        id: 115928397,
        name: "Ken Darby",
        position: 40,
      },
      {
        id: 115928398,
        name: "Billy Rhodes",
        position: 41,
      },
      {
        id: 115928399,
        name: "George Ministeri",
        position: 42,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "PAs",
      block_type: "nameonly",
      column_flow: "horizontal",
      column_width: 50,
      columns: 2,
      dot_leaders: 0,
      extra_lines_below: 0,
      id: 396403,
      name_on_left: 0,
      position: 38,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: "Production Assistants\n(2 Columns)",
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        id: 115928415,
        name: "Charles Becker",
        position: 59,
      },
      {
        id: 115928416,
        name: "Ken Darby",
        position: 60,
      },
      {
        id: 115928417,
        name: "Little Billy' Rhodes",
        position: 61,
      },
      {
        id: 115928418,
        name: "George Ministeri",
        position: 62,
      },
      {
        id: 115928419,
        name: "Karl 'karchy' Kosiczky",
        position: 63,
      },
      {
        id: 115928420,
        name: "Meinhardt Raabe",
        position: 64,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "PAs-2",
      block_type: "nameonly",
      column_flow: "horizontal",
      column_width: 25,
      columns: 4,
      dot_leaders: 0,
      extra_lines_below: 0,
      id: 396404,
      name_on_left: 0,
      position: 58,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: "Stunts\n(4 Columns)",
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "special-thanks",
      block_type: "nameonly",
      column_flow: "horizontal",
      column_width: 33,
      columns: 3,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "SPECIAL THANKS\n",
      id: 396407,
      name_on_left: 0,
      position: 77,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading:
        "(3 Columns)\n(There's no rule saying you have to center everything.)\nkpcokdsopck\n\n",
      text_alignment: "left",
    },
  },
  {
    items: [
      {
        id: 115928475,
        name: "Lucretia Rudolph Garfield",
        position: 121,
      },
      {
        id: 115928476,
        name: "Margaret Mackall Smith Taylor",
        position: 122,
      },
      {
        id: 115928477,
        name: "Martha Washington",
        position: 123,
      },
      {
        id: 115928478,
        name: "Elizabeth Kortright Monroe",
        position: 124,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
      {
        id: 115928433,
        name: "Lucretia Rudolph Garfield",
        position: 78,
      },
      {
        id: 115928434,
        name: "Margaret Mackall Smith Taylor",
        position: 79,
      },
      {
        id: 115928435,
        name: "Martha Washington",
        position: 80,
      },
      {
        id: 115928436,
        name: "Elizabeth Kortright Monroe",
        position: 81,
      },
      {
        id: 115928437,
        name: "Martin Van Buren",
        position: 82,
      },
      {
        id: 115928438,
        name: "Frances Folsom Cleveland",
        position: 83,
      },
      {
        id: 115928439,
        name: "Schuyler Colfax",
        position: 84,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "special-thanks-2",
      block_type: "nameonly",
      column_flow: "horizontal",
      column_width: 30,
      columns: 3,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "SPECIAL THANKS",
      id: 396401,
      name_on_left: 0,
      position: 120,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: '(Bulleted "Open" blocks can save a lot of space.)\n\n',
      text_alignment: "justified",
    },
  },
  {
    items: [
      {
        blurb:
          "The SONG block type is useful for any licensed material\nlike music, stock footage, or works of art.",
        id: 115928517,
        position: 164,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "explainer-3",
      block_type: "blurb",
      column_flow: "horizontal",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "3.",
      id: 396409,
      name_on_left: 0,
      position: 163,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        id: 115928518,
        position: 166,
        song_details:
          "Written by Composer Number One\nPerformed by Artist Number One\nCourtesy of Label Number One\nBy arrangement with Distributor Number One",
        song_title: '"Song Number One"',
      },
      {
        id: 115928519,
        position: 167,
        song_details:
          "Written by Composer Number Two\nPerformed by Artist Number Two\nCourtesy of Label Number Two\nBy arrangement with Distributor Number Two",
        song_title: '"Song Number Two"',
      },
      {
        id: 115928520,
        position: 167,
        song_details:
          "Written by Composer Number Three\nPerformed by Artist Number Three\nCourtesy of Label Number Three\nBy arrangement with Distributor Number Three",
        song_title: '"Song Number Three"',
      },
      {
        id: 115928521,
        position: 167,
        song_details:
          "Written by Composer Number Four\nPerformed by Artist Number Four\nCourtesy of Label Number Four\nBy arrangement with Distributor Number Four",
        song_title: '"Song Number Four"',
      },
      {
        id: 115928521,
        position: 167,
        song_details:
          "Written by Composer Number Five\nPerformed by Artist Number Five\nCourtesy of Label Number Five\nBy arrangement with Distributor Number Five",
        song_title: '"Song Number Five"',
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "songs",
      block_type: "song",
      column_flow: "horizontal",
      column_width: 20,
      columns: 3,
      dot_leaders: 0,
      extra_lines_below: 0,
      horizontal_gap: 0,
      heading: "SONGS",
      id: 396397,
      name_on_left: 0,
      position: 165,
      ragged_gutter: 0,
      rolling_single: 1,
      side_by_side: 0,
      subheading: "",
      text_alignment: "gutter",
    },
  },
  {
    items: [
      {
        blurb:
          "With a LOGO block you can pull from our 4,000+ logo library,\nor upload your own custom images.",
        id: 115928523,
        position: 172,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "right",
      block_name: "explainer-4",
      block_type: "blurb",
      column_flow: "horizontal",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "4.",
      id: 396411,
      name_on_left: 0,
      position: 171,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 1,
      subheading: "",
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        blurb: "No. 88888",
        id: 114854044,
        logo: "mpa",
        logo_fullres_static_path: "mpa/deriv/mpa.png",
        logo_height: 2048,
        logo_offset_x: 0,
        logo_offset_y: 0,
        logo_scale: 1,
        logo_thumbnail_static_path: "mpa/deriv/mpa_thumbnail.png",
        logo_title: "MPA",
        logo_width: 2048,
        position: 72.1875,
      },
      {
        id: 114857096,
        logo: "alexa",
        logo_fullres_static_path: "alexa/deriv/alexa.png",
        logo_height: 96,
        logo_offset_x: 0,
        logo_offset_y: 0,
        logo_scale: 1,
        logo_thumbnail_static_path: "alexa/deriv/alexa_thumbnail.png",
        logo_title: "ALEXA",
        logo_width: 524,
        position: 72.328125,
      },
      {
        id: 114857093,
        logo: "indiegogo",
        logo_fullres_static_path: "indiegogo/deriv/indiegogo.png",
        logo_height: 523,
        logo_offset_x: 0,
        logo_offset_y: 0,
        logo_scale: 1,
        logo_thumbnail_static_path: "indiegogo/deriv/indiegogo_thumbnail.png",
        logo_title: "Indiegogo (Color)",
        logo_width: 1000,
        position: 72.375,
      },
      {
        id: 114857094,
        logo: "tribeca-film-institute",
        logo_fullres_static_path:
          "tribeca-film-institute/deriv/tribeca-film-institute.png",
        logo_height: 435,
        logo_offset_x: 0,
        logo_offset_y: 0,
        logo_scale: 1,
        logo_thumbnail_static_path:
          "tribeca-film-institute/deriv/tribeca-film-institute_thumbnail.png",
        logo_title: "Tribeca Film Institute",
        logo_width: 2048,
        position: 72.421875,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "logos-1",
      block_type: "logo",
      column_flow: "",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "gfgdfgd",
      id: 396412,
      name_on_left: 0,
      position: 173,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: "dfgdfg",
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        id: 112958226,
        logo: "alexa",
        logo_fullres_static_path: "alexa/deriv/alexa.png",
        logo_height: 96,
        logo_offset_x: 0,
        logo_offset_y: 0,
        logo_scale: 1,
        logo_thumbnail_static_path: "alexa/deriv/alexa_thumbnail.png",
        logo_title: "ALEXA",
        logo_width: 524,
        position: 115.4375,
      },
      {
        id: 113254038,
        logo: "iatse",
        logo_fullres_static_path: "iatse/deriv/iatse.png",
        logo_height: 2048,
        logo_offset_x: 0,
        logo_offset_y: 0,
        logo_scale: 1,
        logo_thumbnail_static_path: "iatse/deriv/iatse_thumbnail.png",
        logo_title: "IATSE",
        logo_width: 2048,
        position: 115.703125,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "logos-2",
      block_type: "logo",
      column_flow: "",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      id: 396414,
      name_on_left: 0,
      position: 175,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        id: 112958230,
        logo: "ifp",
        logo_fullres_static_path: "ifp/deriv/ifp.png",
        logo_height: 640,
        logo_offset_x: 0,
        logo_offset_y: 0,
        logo_scale: 1,
        logo_thumbnail_static_path: "ifp/deriv/ifp_thumbnail.png",
        logo_title: "ifp",
        logo_width: 1024,
        position: 117,
      },
      {
        id: 112958227,
        logo: "film-independent-orange-vertical",
        logo_fullres_static_path:
          "film-independent-orange-vertical/deriv/film-independent-orange-vertical.png",
        logo_height: 288,
        logo_offset_x: 0,
        logo_offset_y: 0,
        logo_scale: 1,
        logo_thumbnail_static_path:
          "film-independent-orange-vertical/deriv/film-independent-orange-vertical_thumbnail.png",
        logo_title: "Film Independent (Color, Vertical)",
        logo_width: 288,
        position: 117.25,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "logos-3",
      block_type: "logo",
      column_flow: "",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      id: 396410,
      name_on_left: 0,
      position: 177,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        blurb:
          "Finally, BLURB blocks are useful for legal, copyright, or dedications:\n",
        id: 115928524,
        position: 180,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "explainer-5",
      block_type: "blurb",
      column_flow: "horizontal",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "5.",
      id: 396399,
      name_on_left: 0,
      position: 179,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        blurb:
          "The characters and events portrayed in this motion picture are fictitious. Any similarity to actual persons, living or dead, or to actual events is purely coincidental.\n\nOwnership of this motion picture is protected under the laws of the United States of America and other countries. Any unauthorized duplication, distribution or exhibition of this motion picture or any part thereof (including soundtrack) could result in criminal prosecution as well as civil liability.",
        id: 115928525,
        position: 182,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "legal",
      block_type: "blurb",
      column_flow: "horizontal",
      column_width: 40,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "\n",
      id: 396405,
      name_on_left: 0,
      position: 181,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: "",
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        blurb:
          "Copyright © 20__ [INSERT COPYRIGHT HOLDER]\nAll Rights Reserved.",
        id: 115928526,
        position: 184,
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "copyright",
      block_type: "blurb",
      column_flow: "",
      column_width: 100,
      columns: 1,
      dot_leaders: 0,
      extra_lines_below: 0,
      id: 396406,
      name_on_left: 0,
      position: 183,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: "",
      text_alignment: "center",
    },
  },
  {
    items: [
      {
        id: 115928527,
        name: "endcrawl.com/app",
        position: 186,
        role: "Where do I sign in to my project?",
      },
      {
        id: 115928528,
        position: 187,
      },
      {
        id: 115928529,
        name: "Yes. And they're unlimilited.",
        position: 188,
        role: "Can I add more project collaborators?",
      },
      {
        id: 115928530,
        name: "Yes. Also unlimilited.",
        position: 189,
        role: "Can I make my own renders?",
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "faq",
      block_type: "rolename",
      column_flow: "",
      column_width: 50,
      columns: 2,
      dot_leaders: 0,
      extra_lines_below: 0,
      heading: "FAQ",
      id: 396402,
      name_on_left: 0,
      position: 185,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      text_alignment: "gutter",
    },
  },
  {
    items: [
      {
        id: 115928536,
        position: 196,
        role: "End Titles made with",
      },
    ],
    options: {
      balance_columns: 0,
      block_inset: "",
      block_name: "endcrawl-credit",
      block_type: "rolename",
      column_flow: "",
      column_width: 50,
      columns: 2,
      dot_leaders: 0,
      extra_lines_below: 0,
      id: 396400,
      name_on_left: 0,
      position: 195,
      ragged_gutter: 0,
      rolling_single: 0,
      side_by_side: 0,
      subheading: "",
      text_alignment: "gutter",
    },
  },
];

// project settings

const fontStyle = {
  blurb: {
    color: "#ffffff",
    filename: "BarlowSemiCondensed-SemiBold.ttf",
    font_family: "Barlow Semi-Condensed",
    font_pkey: 992493,
    font_size: 24,
    font_style: "normal",
    font_weight: 600,
    font_weight_defined: 600,
    font_weight_desired: 700,
    free: 0,
    letter_spacing: 0,
    project_fkey: 111470,
    project_font_pkey: 92215,
    property: "blurb",
    small_caps: 0,
    text_stroke: 0,
    text_transform: "none",
  },
  heading: {
    color: "#c332ad",
    filename: "Raleway-Bold.ttf",
    font_family: "Raleway",
    font_pkey: 994253,
    font_size: 70,
    font_style: "normal",
    font_weight: 700,
    font_weight_defined: 700,
    font_weight_desired: 700,
    free: 0,
    letter_spacing: 0,
    project_fkey: 111470,
    project_font_pkey: 92220,
    property: "heading",
    small_caps: 0,
    text_stroke: 0,
    text_transform: "none",
  },
  logo: {
    color: "#ffffff",
    filename: "BarlowSemiCondensed-SemiBold.ttf",
    font_family: "Barlow Semi-Condensed",
    font_pkey: 992493,
    font_size: 24,
    font_style: "normal",
    font_weight: 600,
    font_weight_defined: 600,
    font_weight_desired: 700,
    free: 0,
    letter_spacing: 0,
    project_fkey: 111470,
    project_font_pkey: 92213,
    property: "logo",
    small_caps: 0,
    text_stroke: 0,
    text_transform: "none",
  },
  name: {
    color: "#0091ff",
    filename: "BarlowSemiCondensed-Bold.ttf",
    font_family: "Barlow Semi-Condensed",
    font_pkey: 992494,
    font_size: 30,
    font_style: "normal",
    font_weight: 700,
    font_weight_defined: 700,
    font_weight_desired: 700,
    free: 0,
    letter_spacing: 0,
    project_fkey: 111470,
    project_font_pkey: 92216,
    property: "name",
    small_caps: 0,
    text_stroke: 0,
    text_transform: "camelcaps",
  },
  role: {
    color: "#5f4e4e",
    filename: "BarlowSemiCondensed-Regular.ttf",
    font_family: "Barlow Semi-Condensed",
    font_pkey: 992491,
    font_size: 26,
    font_style: "normal",
    font_weight: 400,
    font_weight_defined: 400,
    font_weight_desired: 700,
    free: 0,
    letter_spacing: 0,
    project_fkey: 111470,
    project_font_pkey: 92217,
    property: "role",
    small_caps: 0,
    text_stroke: 0,
    text_transform: "none",
  },
  song_details: {
    color: "#700f0f",
    filename: "BarlowSemiCondensed-Medium.ttf",
    font_family: "Barlow Semi-Condensed",
    font_pkey: 992492,
    font_size: 24,
    font_style: "normal",
    font_weight: 500,
    font_weight_defined: 500,
    font_weight_desired: 700,
    free: 0,
    letter_spacing: 0,
    project_fkey: 111470,
    project_font_pkey: 92214,
    property: "song_details",
    small_caps: 0,
    text_stroke: 0,
    text_transform: "none",
  },
  song_title: {
    color: "#b82e2e",
    filename: "BarlowSemiCondensed-Bold.ttf",
    font_family: "Barlow Semi-Condensed",
    font_pkey: 992494,
    font_size: 35,
    font_style: "normal",
    font_weight: 700,
    font_weight_defined: 700,
    font_weight_desired: 700,
    free: 0,
    letter_spacing: 0,
    project_fkey: 111470,
    project_font_pkey: 92219,
    property: "song_title",
    small_caps: 0,
    text_stroke: 0,
    text_transform: "uppercase",
  },
  subheading: {
    color: "#ffffff",
    filename: "BarlowSemiCondensed-SemiBold.ttf",
    font_family: "Barlow Semi-Condensed",
    font_pkey: 992493,
    font_size: 24,
    font_style: "normal",
    font_weight: 600,
    font_weight_defined: 600,
    font_weight_desired: 700,
    free: 0,
    letter_spacing: 0,
    project_fkey: 111470,
    project_font_pkey: 92218,
    property: "subheading",
    small_caps: 0,
    text_stroke: 0,
    text_transform: "none",
  },
};

const settings = {
  aspect_ratio: 2,
  fps: 24,
  frame_height: 2048,
  frame_length: 0,
  frame_offset: 0,
  frame_width: 4096,
  gutter: 4,
  gutter_multi: 1,
  has_automatic_target_duration: 0,
  is_cards: 0,
  line_height: {
    default: 1.5,
    max: 2,
    min: 1.05,
  },
  matte: "center",
  matte_alpha: "ff",
  matte_color: "#000000",
  page_break_inside_blocks: 1,
  pixel_aspect_x: 1,
  pixel_aspect_y: 1,
  playback_fps: 23.976,
  ppf: 8,
  resolution: "4k",
  scale: 4,
  screen_height: 2160,
  screen_width: 4096,
  settled_tier: -1,
  slate: 1,
  solo_beat: 2,
  standard: 1,
  target_duration: 650,
  target_tolerance: 24,
  targeting_mode: "locked",
  tier: 1,
  title: "Kartikye Gupta Personal Demo",
  title_safe_hd_crop: 1,
  title_safe_height: 2048,
  title_safe_height_ratio: 0.8,
  title_safe_width: 3072,
  title_safe_width_ratio: 0.8,
  variant: "",
};

export { defaults, credits, fontStyle, settings };
